$(document)
  .on('turbolinks:load', () =>
    //#add <sup> to registration marks
    $('body :not(script, iframe)').contents()
      .filter(function() { return this.nodeType === 3 })
      .replaceWith(function() {
        return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>')
      })
  )
